// these error codes should match the server-side
export const ERROR_APPLICATION = "ERROR_APPLICATION";
export const ERROR_ACCESS_DENIED = "ERROR_ACCESS_DENIED";
export const ERROR_NO_RECORD_FOUND = "ERROR_NO_RECORD_FOUND";
export const ERROR_NO_ROWS_UPDATED = "ERROR_NO_ROWS_UPDATED";
// Raised by the web, not the api: axios gave up waiting for the response. The api may still be
// working on the request, so a caller must not read this as "nothing happened".
export const ERROR_REQUEST_TIMEOUT = "ERROR_REQUEST_TIMEOUT";
export const VALIDATION_DEVELOPER_ALREADY_HAS_ACCESS = "VALIDATION_DEVELOPER_ALREADY_HAS_ACCESS";
export const VALIDATION_WORKFLOW_ALREADY_ACTIVE = "VALIDATION_WORKFLOW_ALREADY_ACTIVE";
